import { useEffect, useMemo, } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import * as uiHelpers from "../ParentUsersUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useParentUsersUIContext } from "../ParentUsersUIContext";

export function ParentUsersTable() {
  // Parent Users UI Context
  const parentUsersUIContext = useParentUsersUIContext();
  const parentUsersUIProps = useMemo(() => {
    return {
      ids: parentUsersUIContext.ids,
      setIds: parentUsersUIContext.setIds,
      queryParams: parentUsersUIContext.queryParams,
      setQueryParams: parentUsersUIContext.setQueryParams
    };
  }, [parentUsersUIContext]);

  // Getting curret state of Parent Users list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );
  const { totalCount, userIds, entities, listLoading } = currentState;
  
  // Parent Users Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    parentUsersUIProps.setIds(userIds);
    dispatch(actions.getParentUsers(parentUsersUIProps.queryParams));
    return () => dispatch(actions.cleanUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIds, parentUsersUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "tcKimlikNo",
      text: "TC Kimlik No",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentName",
      text: "Öğrenci",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: parentUsersUIProps.queryParams.pageSize,
    page: parentUsersUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                parentUsersUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: parentUsersUIProps.ids,
                setIds: parentUsersUIProps.setIds,
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}